import { combineReducers } from "redux";
import profileReducer from "./profileReducer";
import roleReducer from "./roleReducer";

const allReducers = combineReducers({
    roleReducer: roleReducer,
    profileReducer: profileReducer
});

export default allReducers;